"use client";

import React from "react";
import { cn } from "@/lib/utils";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
	variant?: "default" | "outline" | "soft";
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
	({ className, variant = "default", ...props }, ref) => {
		const baseClasses =
			"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium";

		const variants: Record<string, string> = {
			default: "border-transparent bg-[#A7FF5E]/20 text-[#12301b]",
			outline: "border-[#A7FF5E] text-[#12301b]",
			soft: "border-transparent bg-gray-100 text-gray-700",
		};

		return (
			<span
				ref={ref}
				className={cn(baseClasses, variants[variant], className)}
				{...props}
			/>
		);
	}
);

Badge.displayName = "Badge";

export { Badge };
